// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_G_S1x","content":"index_content_tgqn8","nav":"index_nav_KBwFt"};